//判断是否是图片
export function ifImg(attachItem) {
  if (!attachItem) return false
  const name = attachItem.name || ''
  const url = attachItem.url || ''
  return (
    /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga|svg)$/i.test(name) ||
    /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga|svg)$/i.test(url)
  )
}
//判断是否是PDF文件
export function ifPdf(attachItem) {
  if (!attachItem) return false
  const name = attachItem.name || ''
  const url = attachItem.url || ''
  return /\.pdf$/i.test(name) || /\.pdf$/i.test(url)
}
//判断是否是excel
export function ifExcel(attachItem) {
  if (!attachItem) return false
  const name = attachItem.name || ''
  const url = attachItem.url || ''
  return /\.(xlsx|xls)$/i.test(name) || /\.(xlsx|xls)$/i.test(url)
}
//判断是否是rar
export function ifRar(attachItem) {
  if (!attachItem) return false
  const name = attachItem.name || ''
  const url = attachItem.url || ''
  return /\.(rar)$/i.test(name) || /\.(rar)$/i.test(url)
}
//判断是否是zip
export function ifZip(attachItem) {
  if (!attachItem) return false
  const name = attachItem.name || ''
  const url = attachItem.url || ''
  return /\.(zip)$/i.test(name) || /\.(zip)$/i.test(url)
}
//判断是否是word
export function ifWord(attachItem) {
  if (!attachItem) return false
  const name = attachItem.name || ''
  const url = attachItem.url || ''
  return /\.(doc|docs|docx)$/i.test(name) || /\.(doc|docs|docx)$/i.test(url)
}
